import { photoFormatRule } from 'validations';

export default function replacePhotoSrcToSmall(src: string): string {
  return src.replace(photoFormatRule, (format) => `-s${format}`);
}
